document.addEventListener('DOMContentLoaded', function() {
    // Get all '.sticky-button' elements.
    var stickyButtons = document.querySelectorAll('.sticky-button');

    // Add a click event listener to each button
    stickyButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            // Determine which form to toggle based on button's class
            var buttonClass = button.className.match(/sticky-button-(\w+)/);
            if (buttonClass) {
                var formClass = 'form-reveal-' + buttonClass[1]; // Constructs form class from button class
                var formReveal = document.querySelector('.' + formClass);
                if (formReveal) {
                    // Toggle the 'active' class on the button and the related form
                    button.classList.toggle('active');
                    formReveal.classList.toggle('active');
                    // document.body.classList.toggle('overflow-hidden');
                    // document.documentElement.classList.toggle('fixed-height');
                }
            }
        });
    });

    // Handle closing of forms
    var hideForms = document.querySelectorAll('.hide-form');
    hideForms.forEach(function(hideForm) {
        hideForm.addEventListener('click', function() {
            var formReveal = hideForm.closest('.form-reveal');
            if (formReveal) {
                var activeButton = document.querySelector('.sticky-button.active');
                if (activeButton) {
                    activeButton.classList.remove('active');
                }
                formReveal.classList.remove('active');
                // document.body.classList.remove('overflow-hidden');
                // document.documentElement.classList.remove('fixed-height');
            }
        });
    });
});
